/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-08 17:10:19
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-22 14:55:55
 */

import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const Authmage: Array<RouteRecordRaw> = [
  {
    path: '/Authmage',
    component: Layout,
    redirect: '/account',
    meta: {
      title: 'jurisdiction',
      icon1: 'account1',
      icon2: 'account2',
      noCache: true
    },
    children: [
      {
        path: 'account',
        component: () => import('@/views/authManage/account.vue'),
        name: 'accountmage',
        meta: {
          title: 'accounts',
          noCache: true
        }
      },
      {
        path: 'role',
        component: () => import('@/views/authManage/role.vue'),
        name: 'rolemage',
        meta: {
          title: 'roles',
          noCache: true
        }
      }
    ]
  },
]

export default Authmage
